function removeInvalidRolesFromSlides(swiperInstance) {
    if (!swiperInstance || !swiperInstance.slides) return;
    swiperInstance.slides.forEach(function(slide) {
        if (slide.tagName === 'A' && slide.hasAttribute('role')) {
            slide.removeAttribute('role');
        }
    });
}

var swiper = new Swiper(".page-header__slider .mySwiper", {
    slidesPerView: 2,
    spaceBetween: 15,
    autoHeight: true,
    a11y: { enabled: false },
    navigation: {
        nextEl: ".page-header__slider .swiper-button-next",
        prevEl: ".page-header__slider .swiper-button-prev",
    },
    breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1440: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
      },
    on: {
        init: function () { removeInvalidRolesFromSlides(this); },
        slideChange: function () { removeInvalidRolesFromSlides(this); },
        resize: function () { removeInvalidRolesFromSlides(this); }
    }
});
